module.exports = __webpack_public_path__ + "img/about-6.0614ac06.png";